<!-- 公告 -->
<template>
    <div
        v-if="content"
        class="notice-wrap"
        :class="type"
    >
        <veui-icon class="icon" name="exclamation-circle-solid"/>
        <div class="content">{{ content }}</div>
    </div>
</template>

<script>
/**
 * @file index.vue
 * @author dingzhenyue
 * @desc 公告组件
 */
import {Icon} from 'veui';
import 'veui-theme-dls-icons/exclamation-circle-solid';

export default {
    name: 'notice',
    components: {
        'veui-icon': Icon
    },
    data() {
        return {
        };
    },
    props: {
        // 公告类型，主要控制展示颜色，默认是蓝色
        // warning:黄色警告
        type: {
            'type': String,
            'default': ''
        },
        // 公告内容
        content: {
            'type': String,
            'default': ''
        }
    }
};
</script>

<style lang='less' scoped>
.notice-wrap {
    height: 50px;
    background: #E5F1FF;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 10px;

    .icon {
        min-width: 15px;
        margin-right: 12px;
        color: #3855D5;
    }

    &.warning {
        background: #faad1414;

        .icon {
            color: #FAAD14;
        }
    }
}
</style>
